module.exports = __webpack_public_path__ + "static/media/bagInfant.265bdc84.svg";